(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var blog = document.getElementById('OptivanceBlog');
    if (!blog) return;

    // ── STICKY PILL BAR ─────────────────────────────────────────────
    var filterBar = blog.querySelector('.optivance-blog__filter');
    if (filterBar) {
      const updateStickyTop = () => {
        // Prefer the fixed stuck header; fall back to the static header wrapper
        const stuckHeader = document.querySelector('.site-header--stuck');
        const staticHeader = document.querySelector('.header-sticky-wrapper') || document.querySelector('.site-header');
        let h = 0;
        if (stuckHeader) {
          h = stuckHeader.getBoundingClientRect().height;
        } else if (staticHeader) {
          h = staticHeader.getBoundingClientRect().height;
        }
        filterBar.style.setProperty('--ob-sticky-top', h + 'px');
      };
      updateStickyTop();
      window.addEventListener('resize', updateStickyTop, { passive: true });
      window.addEventListener('scroll', updateStickyTop, { passive: true });

      const stickyObserver = new IntersectionObserver(
        ([entry]) => filterBar.classList.toggle('optivance-blog__filter--stuck', !entry.isIntersecting),
        { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
      );
      stickyObserver.observe(filterBar);
    }

    var pills = blog.querySelectorAll('.optivance-blog__pill');

    // ── TAB FILTER ──────────────────────────────────────────────────
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var url = this.href;

        setActivePill(this);
        filterFetch(url);
        history.pushState({ url: url }, '', url);
      });
    });

    // ── LOAD MORE ────────────────────────────────────────────────────
    attachLoadMore();
    attachShowMoreCards();

    // ── POPSTATE (browser back/forward) ─────────────────────────────
    window.addEventListener('popstate', function () {
      location.reload();
    });

    // ─────────────────────────────────────────────────────────────────
    function setActivePill(active) {
      pills.forEach(function (p) { p.classList.remove('optivance-blog__pill--active'); });
      active.classList.add('optivance-blog__pill--active');
    }

    function filterFetch(url) {
      var grid = blog.querySelector('.optivance-blog__grid');
      if (!grid) return;
      setLoading(grid, true);

      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Replace grid content
          var newGrid = doc.querySelector('.optivance-blog__grid');
          if (newGrid) grid.innerHTML = newGrid.innerHTML;

          // Show/hide featured article section
          var gridSection  = blog.querySelector('.optivance-blog__grid-section');
          var featuredEl   = blog.querySelector('.optivance-blog__featured-section');
          var newFeatured  = doc.querySelector('.optivance-blog__featured-section');

          if (newFeatured) {
            if (featuredEl) {
              featuredEl.innerHTML = newFeatured.innerHTML;
              featuredEl.hidden = false;
            } else if (gridSection) {
              // Re-insert featured section above the grid section
              var clone = newFeatured.cloneNode(true);
              blog.insertBefore(clone, gridSection);
            }
          } else if (featuredEl) {
            featuredEl.hidden = true;
          }

          // Replace pagination
          replacePagination(doc);

          setLoading(grid, false);

          // Smooth scroll to just above filter pills
          var filter = blog.querySelector('.optivance-blog__filter');
          if (filter) {
            var top = filter.getBoundingClientRect().top + window.pageYOffset - 80;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function (err) {
          console.warn('[BlogAjax] filter failed:', err);
          var g = blog.querySelector('.optivance-blog__grid');
          if (g) setLoading(g, false);
        });
    }

    function attachLoadMore() {
      var btn = blog.querySelector('.optivance-blog__load-more-btn[href]');
      if (!btn || btn.dataset.ajaxBound) return;
      btn.dataset.ajaxBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url      = this.href;
        var original = this.textContent.trim();

        this.textContent    = 'Loading…';
        this.style.opacity  = '0.6';
        this.style.pointerEvents = 'none';

        fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var doc  = new DOMParser().parseFromString(html, 'text/html');
            var grid = blog.querySelector('.optivance-blog__grid');

            if (grid) {
              var newCards = doc.querySelectorAll('.optivance-blog__card');
              newCards.forEach(function (card) {
                var clone = card.cloneNode(true);
                clone.style.opacity   = '0';
                clone.style.transform = 'translateY(16px)';
                clone.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
                grid.appendChild(clone);
                requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    clone.style.opacity   = '1';
                    clone.style.transform = 'translateY(0)';
                  });
                });
              });
            }

            replacePagination(doc);
          })
          .catch(function (err) {
            console.warn('[BlogAjax] load more failed:', err);
            var b = blog.querySelector('.optivance-blog__load-more-btn');
            if (b) {
              b.textContent         = original;
              b.style.opacity       = '';
              b.style.pointerEvents = '';
            }
          });
      });
    }

    function attachShowMoreCards() {
      var btn = blog.querySelector('[data-blog-load-more]');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var grid = blog.querySelector('[data-blog-grid]');
        if (!grid) return;

        var perPage = parseInt(this.dataset.perPage, 10) || 12;
        var hidden  = grid.querySelectorAll('.optivance-blog__card--hidden');
        var shown   = 0;

        hidden.forEach(function (card) {
          if (shown >= perPage) return;
          card.classList.remove('optivance-blog__card--hidden');
          card.style.opacity   = '0';
          card.style.transform = 'translateY(16px)';
          card.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              card.style.opacity   = '1';
              card.style.transform = 'translateY(0)';
            });
          });
          shown++;
        });

        var remaining = grid.querySelectorAll('.optivance-blog__card--hidden').length;
        if (remaining === 0) {
          var wrap = btn.closest('[data-blog-load-more-wrap]');
          if (wrap) wrap.remove();
        }
      });
    }

    function replacePagination(doc) {
      var oldPag = blog.querySelector('.optivance-blog__pagination');
      if (oldPag) oldPag.remove();

      var newPag = doc.querySelector('.optivance-blog__pagination');
      if (newPag) {
        var wrap = blog.querySelector('.optivance-blog__grid-section .optivance-blog__wrap');
        if (wrap) {
          wrap.appendChild(newPag.cloneNode(true));
          attachLoadMore();       // server-side href pagination
          attachShowMoreCards();  // client-side reveal pagination
        }
      }
    }

    function setLoading(el, on) {
      el.style.opacity      = on ? '0.35' : '1';
      el.style.pointerEvents = on ? 'none' : '';
      el.style.transition   = 'opacity 0.2s ease';
    }
  });
})();
